export const SERVER_STATUS_CODES = {
  PPI1_USER_NOT_FOUND: 'PPI1',
  PPI3_LOCK_USER: 'PPI3',
  PPI4_USER_IS_INACTIVE: 'PPI4',
  PPI5_RESEND_OTP_TOO_MANY_TIMES: 'PPI5',
  PPI6_FORCE_RESET_PASSWORD: 'PPI6',
  PPI7_CLIENTUSER_CANNOT_LOGIN_HERE: 'PPI7',
  PPI12_ACCOUNT_EXIST: 'PPI12',
  PPI10_CLIENT_ARCHIVE: 'PPI10',
  PPI11_ACCOUNT_NOT_EXIST: 'PPI11',
  PPI13_NULL_OR_EMPTY_VALUE: 'PPI13',
  PPI18_UPDATE_ROLE_AND_PERMISSION: 'PPI18',
  PPI21_DUPLICATE_ACCOUNT: 'PPI21',
  PPI9_CLIENT_NOT_EXIST: 'PPI9',
  PPP05_COLUMN_IS_REQUIRED: 'PPP05',
  PPF01_CHECK_NUMBER_DUPLICATED: 'PPF01',
  PPF02_CHECK_NUMBER_DUPLICATED_ON_CORE: 'PPF02',
  DUP01_CHECK_STATUS_DUPLICATED: 'Dup01',
  DUP02_CHECK_STATUS_DUPLICATED: 'Dup02',
  DUP03_CHECK_STATUS_DUPLICATED: 'Dup03',
  DUP04_CHECK_STATUS_DUPLICATED: 'Dup04',
  DUP05_CHECK_STATUS_DUPLICATED: 'Dup05',
  DUP06_CHECK_STATUS_DUPLICATED: 'Dup06',
  PPI1SSO_USER_NOT_FOUND: 'PPI1SSO',
  PPI3SSO_LOCK_USER: 'PPI3SSO',
  PPI4SSO_USER_IS_INACTIVE: 'PPI4SSO',
  PPI9SSO_EXCEPTION: 'PPI9SSO',
  PPI19_FORBIDDEN: 'PPI19',
}
